var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slot-table__item slot-table__item_wrap"},[_c('div',{staticClass:"slot-table__cell slot-table__cell_time"},[_vm._v(_vm._s(_vm.item.timeHour))]),_c('div',{staticClass:"slot-table__cell slot-table__cell_quant"},[_c('b',[_vm._v(_vm._s(_vm.item.quantity))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }